<template>
    <div class="avideo">
        <template v-if="hasVideo">
            <video  
                loop
                autoplay
                muted
                playsinline
                class="lazyload"
                ref="video"
                :data-poster="browserSrc"
                preload="none">
                <source v-for="src in srcs" :key="src" :src="src" />
            </video>
            <loader class="overlay" />
        </template>
       
        <template v-else>
            <limg :src="poster" alt="" />
        </template>
    </div>
</template>

<script>
import { debounce } from "debounce";
import features from "../features"


function isInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    var height = window.innerHeight || document.documentElement.clientHeight;
    var width = window.innerWidth || document.documentElement.clientWidth;
    return (
        (bounding.top >= 0 && bounding.top <= height) || (bounding.bottom <= height && bounding.bottom >= 0) || (bounding.top <= 0 && bounding.bottom >= height)
        // NOTE: check that elem is visible on X axis, getBoundingClientRect returns left and x relative to container,
        // so if elem in horizontaly scrollable container left and x could be > width
    );
};

export default {
    name: "AutoPlayVideo",
    props: {
        poster: {
            type: String,
            default: () => ""
        },
        srcs: {
            type: Array,
            default: () => []
        }
    },
    mounted() {
        this.checkScrollDebounced = debounce(this.checkScroll, 250);
        window.addEventListener("scroll", this.checkScrollDebounced, false);
        window.addEventListener("resize", this.checkScrollDebounced, false);
        setTimeout(() => this.checkScrollDebounced(), 100);
    },
    beforeDestroy() {
        window.removeEventListener("scroll", this.checkScrollDebounced);
        window.removeEventListener("resize", this.checkScrollDebounced);
    },
    computed: {
        hasVideo(){
            if(!this.poster) return true;
                return !(features.isIE || features.isTouch || features.width <1280); ;
        },

        browserSrc() {
            return Modernizr.webp ? this.poster + ".webp" : this.poster;
        }
    },
    methods: {
        checkScroll() {
            var video = this.$refs.video;
            if (!video) return;

            if (isInViewport(video)) {
                video.play();
            } else {
                video.pause();
            }
        }
    }
};
</script>
<style lang="scss">
.avideo {
    position: relative;
    background: $lazy-background;

    .lazyload,
    .lazyloading {
        background: $lazy-background;
    }

    .lazyloaded {
        background: transparent;

        ~ .loader {
            display: none !important;
        }
    }

    video {
        display: block;
        width: 100%;
        height: 100%;
    }

    .limage {
        display: block;
        width: 100%;
        height: 100%;
    }

    .loader {
        position: absolute;
        display: none;
        top: 50%;
        left: 50%;
        width: 64px;
        height: 64px;
        transform: translate(-50%, -50%);
        z-index: 1;

        div {
            display: block;
            position: absolute;
            width: 51px;
            height: 51px;
            margin: 6px;
            border: 6px solid #fff;
            border-radius: 50%;
            animation: loader 1.2s ease-in-out infinite;
            border-color: $lazy-color transparent transparent transparent;

            &:nth-child(1) {
                animation-delay: -0.45s;
            }
            &:nth-child(2) {
                animation-delay: -0.3s;
            }
            &:nth-child(3) {
                animation-delay: -0.15s;
            }
        }

        @keyframes loader {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    }
}
</style>
